import { useCallback } from 'react';
import { gql, useMutation } from '@apollo/client';
import { groupsQuery } from './groups';
import { georolesQuery } from './georoles';

const query = gql`
  mutation RevokeAll($idnumber: String!) {
    revokeAll(idnumber: $idnumber)
  }
`;

interface Args {
  idnumber: string;
}

type HookReturns = [(idnumber: string) => Promise<void>, { loading: boolean }];

export default function useRevokeAll(): HookReturns {
  const [mutate, { loading, error }] = useMutation<unknown, Args>(query, {
    refetchQueries: [groupsQuery, georolesQuery],
  });
  if (error != null) throw error;

  const action = useCallback(
    async (idnumber: string): Promise<void> => {
      await mutate({ variables: { idnumber } });
    },
    [mutate]
  );

  return [action, { loading }];
}
